// MCP consent handoff (openspec/changes/add-qportal-mcp-connectors, design §5.5). After Allow or Deny the API returns a
// continueUrl on the OAuth authorization endpoint. The portal follows it only when it is exactly that endpoint on the
// configured issuer; anything else is refused, so the consent page can never become an open redirect.
const absoluteHttpUrl = (value) => {
    if (typeof value !== 'string' || !value)
        return;
    try {
        const url = new URL(value);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url : undefined;
    }
    catch {
        return;
    }
};
// The issuer is REACT_APP_MCP_ISSUER when it is set to an absolute URL. Otherwise it is the origin of the portal API:
// one host serves the issuer and the portal API (decision 2026-11-03, design §0). Read at call time, never cached.
// Note: the webpack env plugin substitutes "MISSING_ENV_VAR" for unset variables; that is not a URL and is ignored.
export const mcpIssuer = () => {
    const configured = absoluteHttpUrl(process.env.REACT_APP_MCP_ISSUER);
    if (configured)
        return new URL(configured.pathname.endsWith('/') ? configured.href : configured.href + '/');
    const api = absoluteHttpUrl(process.env.REACT_APP_API_BASE_URL);
    return api ? new URL('/', api) : undefined;
};
export const safeContinueUrl = (value) => {
    if (typeof value !== 'string' || /[\\\x00-\x20\x7f]/.test(value))
        return;
    const issuer = mcpIssuer();
    const url = absoluteHttpUrl(value);
    if (!issuer || !url)
        return;
    const endpoint = new URL('connect/authorize', issuer);
    if (url.username || url.password || url.hash)
        return;
    if (url.origin !== issuer.origin || url.pathname !== endpoint.pathname)
        return;
    return url.href;
};
